/** Load Styles */
import './main.css'

/** Load Components */
import { setupHeaderNavigation } from "./components/headerNavigation"
import { setupCourseHero } from './components/courseHero';
import { setupCourseOverview } from './components/courseOverview';
import { setupCourseBox } from './components/courseBox';
import { setupPathCourses } from './components/pathCourses';
import { setupAccordions } from './components/accordion';
import { setupFooter } from './components/footer';

/** Add Additional Scripts */
import { styleProfilePage } from './scripts/_styleProfilePage';
import { moveModulesSearchBar } from './scripts/_moveModulesSearchBar';
import { addModulesSidebarBanner } from './scripts/_addModulesSidebarBanner';
import { addViewAllModulesLink } from './scripts/_addViewAllModulesLink';
import { checkUserPlanEnrollments } from './scripts/_checkUserPlanEnrollments';

let setupComplete;

if (!setupComplete) {
  /** Run Scripts */
  setupHeaderNavigation();
  setupCourseBox();
  setupCourseHero();
  setupCourseOverview();
  setupPathCourses();
  setupAccordions();
  setupFooter();
  styleProfilePage();
  moveModulesSearchBar();
  addModulesSidebarBanner();
  addViewAllModulesLink();
  checkUserPlanEnrollments();
  setupComplete = true;
} else {
  setupComplete = false;
}